export default {
  title: {
    login: "%{school} - Вход",
    registration: "%{school} - Регистрация",
    subjects: "%{school} - Выбор предмета",
    subject: "%{school} - Предмет",
    offer: "%{school} - Предложение",
    home: "%{school} - Домашняя страница",
    dictionary: "%{school} - Словарь",
    events: "%{school} - События",
    news: "%{school} - Новости",
    profile: "%{school} - Профиль",
    learn: "%{school} - Обучение",
    pay: "%{school} - Оплата предмета",
    checkInSystem: "Укажите ваш Email",
    setPassword: "Введите пароль чтобы войти.",
    createAccount: "Укажите/Обновите даные вашей учетной записи.",
  },
  authCheckEmail: {
    title: "Укажите вашу почту",
    emailCaption: "Электронный адрес",
    continue: "Продолжить",
    or: "или",
  },
  authPassword: {
    title: "Войдите в свой аккаунт",
    inputCaption: "Пароль",
    placeholder: "Введите пароль",
    forgot: "Забыли пароль?",
    submit: "Войти",
  },
  authRegistration: {
    title: "Регистрация аккаунта",
    name: "Имя",
    phone: "Номер телефона",
    password: "Придумайте пароль",
    confirmPassword: "Повторите придуманный пароль",
  },
  totalError: "Упс, щось пішло не так!",
  subjectChangeError: "Не удалось сменить предмет. Попробуйте ещё раз или свяжитесь с вашей школой.",
  email: "Email",
  personalLink: "Персональная ссылка",
  login: "Логин",
  name: "Имя",
  firstLastName: "Фамилия и имя",
  phone: "Телефон",
  formatPhone: "Номер телефона в формате 998…", // todo for leader-online
  aboutMe: "Обо мне",
  fullAge: "Ваш возраст (полных лет)",
  errorAge: "некорректный возраст",
  notNumber: "значение должно быть числом",
  registration: "Регистрация",
  password: "Пароль",
  currentPassword: "Текущий пароль",
  newPassword: "Новый пароль",
  confirmPassword: "Повторите пароль",
  confirmNewPassword: "Повторите новый пароль",
  forgotPassword: "Забыли пароль?",
  passwordsMatch: "Пароли не совпадают",
  resetPassword: "Пароль сброшен успешно, проверьте свой Email.",
  resetConfirm: "Вы желаете сбросить пароль?",
  enter: "Войти",
  studentEnter: "Вход для учеников",
  check: "Дальше",
  signInWithGoogle: "Войти через Google",
  emailIsNotRegistered: "Пользователя с таким адресом не существует",
  logout: "Выйти",
  online: "онлайн",
  offline: "офлайн",
  cancel: "Отменить",
  yes: "Да",
  no: "Нет",
  course: "Курс",
  dictionary: "Словарь",
  events: "События",
  news: "Новости",
  words: "Слова",
  wordsAreHere: "Эти слова находятся здесь:",
  allWords: "Все слова",
  phrases: "Фразы",
  videos: "Видео",
  exercises: "Упражнения",
  theory: "Теория",
  theoryAlt: "Конспект",
  theoryAdditionalFile: "Скачать дополнительный файл (%{filename})",
  topic: "Топик",
  lesson: "Урок",
  lessons: "Уроки",
  profile: "Профиль",
  orders: "Покупки",
  payment: "Оплата",
  leaderboard: "Лидеры",
  leaderboardPerDay: "Лидеры за сегодня",
  time: "Время",
  points: "Баллы",
  myPoints: "Мои баллы за весь период",
  coins: "Монеты",
  courses: "Мои курсы",
  loading: "Загрузка...",
  noTheory: "К этому уроку нет теории",
  startTraining: "Начать тренировку",
  chat: {
    // === chat list / dialog additions ===
    startDialogTitle: "Начать чат",
    startDialogTooltip: "Создать новый диалог",
    messages: "Сообщения",
    unreadOnly: "Только непрочитанные",
    delete: "Удалить",
    send: "Отправить",
    sendHelper: "Ctrl+Enter - для отправки сообщения",
    close: "Закрыть",
    profile: "Профиль",
    lastActivity: "Последняя активность",
    status: "Статус",
    jobTitle: "Название должности",
    tabLabel: "Чат",
    lastOnline: {
      time: "Был онлайн в %{date}",
      weekday: "Был онлайн в %{date}",
      dayMonth: "Был онлайн %{date}",
      monthYear: "Был онлайн в %{date}",
    },
    read: "Прочитано",
    errors: {
      wrongFormatting: "Сообщение содержит неправильное форматирование",
    },
  },
  branches: "Темы",
  easy: "Легко",
  expert: "Эксперт",
  wordToLearn: "Выучить позже",
  iKnowWord: "Я знаю это слово",
  videoVocabulary: "Видео лексика",
  markVideoWatched: "Отметить просмотренным",
  videoWatched: "Просмотрено",
  passed: "пройдено",
  unsupportedExercise: "Данный тип упражнений (%{type}) пока не поддерживается",
  changeCourse: "Сменить курс",
  currentCourse: "Текущий курс",
  allSubjects: "Все предметы",
  all: "Все",
  subject: "Предмет",
  group: "Группа",
  start: "Начать",
  chooseSubject: "Выберите предмет, который вы хотите изучать",
  hourValue: "%{value} ч",
  completed: "Завершено",
  notCompleted: "Не завершено",
  paidBranch: "Эта тема платная. Пожалуйста, купите её, чтобы учиться.",
  buyBranch: "Купить тему за %{price} %{currency}",
  paidSubject: "Этот предмет платный. Пожалуйста, купите его, чтобы учиться.",
  buySubject2: "Купить предмет за %{price} %{currency}",
  decksItemNotOpen: "Чтобы открыть этот урок, вам нужно пройти предыдущий урок",
  decksItemNotPurchasedBranch: "The topic of this lesson is blocked",
  decksItemNotOpenLevel: "Пройдите предыдущий уровень, чтобы открыть урок",
  decksItemNotOpenBranch: "Чтобы открыть этот урок, вам нужно пройти предыдущую тему",
  deckAccessDenied: "Этот урок для вас ещё не доступен",
  openOnDate: "откроется %{date}",
  levelAccessIsDenied: "Материалы этого уровня вам не доступны",
  youAreDeactivated: "Ваш аккаунт был деактивирован, пожалуйста, свяжитесь с вашей школой",
  lockText: {
    p1: "Упс... К сожалению, вы не можете получить доступ к учебным материалам. Работа школы временно приостановлена.",
    p2: "Для получения подробной информации и решения всех вопросов обратитесь к представителям школы.",
  },
  youAreDeactivatedShort: "Ваш аккаунт деактивирован",
  youAreHaveNotPaidOffers: "У вас есть неоплаченные предложения",
  yourCertificates: "Ваши сертификаты",
  emptyDeck: "Урок пуст",
  nextDeck: "Следующий урок",
  next: "Далее",
  proceed: "Продолжить",
  skip: "Пропустить",
  more: "Ещё",
  exit: "Выход",
  details: "Подробнее",
  go: "Перейти",
  profileEdit: "Редактирование профиля",
  userInfo: "Информация о пользователе",
  of: "из",
  back: "Назад",
  levelPackExist: "У вас уже есть этот набор уровней",
  awaitingPayment: "Ожидает оплату",
  bought: "Купленный",
  boughtUntilDate: "Купленный до %{endDate}",
  availableUntilDate: "доступный до %{endDate}",
  showMore: "показать больше",
  hide: "свернуть",
  communication: "Связь со школой",
  askQuestion: "Задать вопрос",
  noDescription: "Описание отсутствует",
  description: "Описание:",
  onePerMonth: "Подписаться на месяц",
  semiannually: "Подписаться на пол года",
  onceAYear: "Подписаться на год",
  stopSubscribe: "Stop Subscribe",
  enable: "Enable Subscribe",
  expired: "Expired",
  buySubject: "Купить предмет",
  buyOffer: "Купить",
  subscribeOffer: "Subscribe offer",
  firstPayment: "Первый платеж",
  accessDaysWarning: "Остался %{smart_count} день |||| Осталось %{smart_count} дней",
  accessDemoDaysWarning: "Демо: Остался %{smart_count} день |||| Демо: Осталось %{smart_count} дней",
  accessDemoButton: "Демо доступ",
  closeButton: "Закрыть",
  existOffer: "There is already an unpaid offer",
  loginInProcess: "Выполняется вход...",
  done: "Выполнено:",
  Levels: {
    empty: "В этом курсе пока нет доступных уровней",
    name: "Уровень:",
  },
  Decks: {
    scormPass: "Зачесть урок",
    proceed: "Далее",
    stayHere: "Остаться здесь",
  },
  Exercises: {
    tabTitle: "Упражнения",
    skip: "Дальше",
    check: "Проверить",
    examCheck: "Отправить",
    typeAnswer: "Введите свой ответ",
    next: "Далее",
    rightAnswerWas: "Правильный ответ был:",
    showRightAnswer: "Показать правильный ответ",
    rightAnswer: "Правильный ответ:",
    congratulation: "Поздравляем!",
    congratText: "Вы выучили все упражнения в этом уроке!",
    wrongAnswer: "Ваш ответ неверный",
    answerSaved: "Ответ сохранен",
    commentToAnswer: "Комментарий к выбранному ответу:",
    appendix: {
      pdf: {
        tooltipButton: "Дополнительные материалы",
      },
    },
    type13: {
      title: "Заполните пропуски, выбрав нужное слово из выпадающего списка",
    },
    type12: {
      title: "Ознакомьтесь с дополнительной информацией",
    },
    type11: {
      title: {
        select: "Выберите правильный ответ",
        keyboard: "Напишите правильный ответ",
      },
    },
    type9: {
      title: {
        select: "Заполните пропуски, выбрав нужное слово",
        keyboard: "Заполните пропуски",
      },
    },
    type8: {
      title: "Найдите соответствия",
    },
    type7: {
      title: {
        text: "Напишите ваш ответ",
        audio: "Запишите аудио ответ",
      },
      recordingIsNotSupported: "Запись звука не поддерживается вашим браузером",
      audioRecordingError: "Ошибка записи звука: ",
      inputLabel: "Ваш ответ",
      addPhotoVideo: "Добавить фото/видео (до %{maxCount} шт.)",
      addPhoto: "Добавить фото (до %{maxCount} шт.)",
      cameraInitialization: "Инициализация...",
      change: "Изменить",
      codeToApprove: "Пароль",
      homework: {
        teacherData: {
          audio: "Аудио комментарий преподавателя",
          audioComment: "Голосовой комментарий преподавателя",
        },
      },
      addFiles: "Добавить файлы",
      limitsHelperText: "Длина текста должна быть не менее %{count} букв",
      photoRequired: "Прикрепите хотя бы одно фото или файл к ответу",
      photoViewerHint: "Изображение можно масштабировать колесом мыши",
    },
    type6: {
      title: "Нарисуйте элемент",
      checkButtonText: "Понятно!",
    },
    type3: {
      title: "Расположите элементы в правильном порядке",
      hint: "Перетащите сюда элементы, расположенные ниже",
    },
    type5: {
      title: "Выберите элементы",
      hint: "Выберите нужные элементы внизу экрана (чтобы выбрать — просто нажмите на них)",
    },
    type2: {
      title: "Выберите пропущенное слово",
    },
  },
  Events: {
    headNotice: "Время события отображается в соответствии с вашим часовым поясом",
    title: "События этой недели",
    startTime: "Время начала",
    finishTime: "Время окончания",
    group: "Группа",
    persons: "%{smart_count} человек |||| %{smart_count} человек",
    leader: "Ведущий",
    tag: "Категория",
    joinedCheckbox: "С регистрацией",
    joined: "Выбрано:",
    interested: "Регистрация",
    registered: "Зарегистрировано",
    enter: "Войти",
    limitPopupInfo: "Вы достигли лимита регистраций на события",
    eventHasStarted: "Событие уже началось!",
    registrationNotice: "Вы успешно зарегистрировались! Кнопка входа будет активна в %{date_and_time}. После этого времени вы не сможете отменить регистрацию на событие",
    registrationNoticeNoUrl: "Вы успешно зарегистрировались! После %{date_and_time} вы не сможете отменить регистрацию на событие",
    cancelRegistration: "Вы действительно хотите отменить регистрацию?",
    calendarLink: "Добавить событие в Google календарь",
    status_planned: "Запланировано",
    status_started: "Начато",
    status_completed_successfully: "Завершено",
    status_last_minute_cancellation: "Отменено в последний момент",
    status_late_cancellation: "Поздняя отмена",
    status_canceled: "Отменено",
    status_moved: "Перенесено",
  },
  statistic: {
    title: "Статистика",
    points: "баллы",
    phrases: "фразы",
    missions: "миссии",
    words: "слова",
    time: "время",
  },
  status: {
    wait_review: "Ожидает проверки",
    on_review: "На проверке",
    approved: "Принято",
    not_approved: "Отклонено",
    not_approved_allow_update: "Отклонено (Переделать)",
    ai_reviewed: "Проверено с помощью ИИ",
  },
  homeworks: {
    tabName: "Домашки",
    todo: "К выполнению",
    done: "Выполненные",
    topic: "Тема",
    lesson: "Урок",
    onlyInMobileApp: "Доступно только в мобильном приложении",
    todoHomework: "ЗАДАНИЕ НА ПРОВЕРКЕ",
    postToDoButton: "Отправить",
    types: {
      homework_todo: "ToDo",
      exercise: "Exercise",
    },
    waitAIReview: "Подождите, ИИ проверяет ответ",
    dontWait: "не ждать",
    checkingHomework: "Проверяю домашнее задание",
  },
  exam: {
    popupTitle: "Урок с экзаменом",
    popupDescr1: "Это урок с экзаменом. Сначала изучите все дополнительные материалы и только после переходите к выполнению упражнений.",
    popupDescr2: 'Как только вы перейдете во вкладку "Упражнения" начнется отсчет времени.',
    popupDescr3: 'Вкладки "Теория" и "Видео" НЕ запускают отсчет времени экзамена.',
    cancelButton: "В следующий раз",
    positiveButton: "Понятно (%{smart_count} попытка)  |||| Понятно (%{smart_count} попытки)",
    questions: "%{smart_count} вопрос |||| %{smart_count} вопросов",
    oneAttempt: "Одна попытка на ответ",
    timeLimit: "Ограничение по времени: %{limit} минут",
    noPause: "Экзамен не может быть приостановлен",
    progress: "Вопрос №%{current} из %{total}",
    closeButton: "Закрыть",
    viewButton: "Просмотреть результаты",
    retakeButton: "Попробовать снова (%{smart_count} попытка)  |||| Попробовать снова (%{smart_count} попытки)",
    finishedPopupTitle: "Результат экзамена",
    examPassed: "Экзамен пройден",
    examNotPassed: "Экзамен не пройден",
    waitHomeworks: "%{smart_count} вопрос на проверке |||| %{smart_count} вопросов на проверке",
    result: "Ваш результат:",
  },
  subjects: {
    unavailable: "В данный момент предмет недоступен",
  },
  orderStatus: {
    approved: "Принято",
    canceled: "Отклонено",
    pending: "Ожидает",
  },
  notificationsTypes: {
    event: "Событие",
    invoice: "Счёт",
    news: "Новости",
    homework: "homework",
    homework_todo: "homework_todo",
    type: {
      exercise: "Homework",
      homework_todo: "Homework To do",
    },
  },
  notificationsAlert: {
    subscribe: "Включить уведомления",
    unsubscribe: "Выключить уведомления",
    instructions: "Нажмите на замочек 🔒 слева от адресной строки и измените разрешение уведомлений как показано на изображении или измените общие настройки браузера.",
    permissionDefault: {
      title: "Подпишитесь на уведомления 🔔",
      body: "Оповещения о сменене статуса ДЗ, начале события, новости, новом задании к выполнению. Никакой рекламы, только уведомления о вашем обучении!",
    },
    permissionDenied: {
      title: "Сейчас оповещения выключены ❌",
      body: "Ранее вы отказались от уведомлений. Без них вы не можете вовремя узнавать о сменене статуса ДЗ, начале события. Чтобы включить уведомления следуйте инструкциям ниже:",
    },
    permissionGranted: {
      title: "Сейчас оповещения включены ✔",
      body: "Вы точно хотите отказаться от уведомлений? Без них вы не можете вовремя узнавать о сменене статуса ДЗ, начале события. Чтобы выключить уведомления следуйте инструкциям ниже:",
    },
  },
  feedbackDialog: {
    sendFeedback: "Отправить отзыв",
    placeholder: "Расскажите о ваших впечатлениях",
    defaultInstruction: "Используйте слайдер чтобы оценить",
    eventInstruction: "Оцените как прошло событие",
    submitError: "Выберите пожалуйста оценку",
    submitSuccess: "Спасибо! Ваш отзыв успешно отправлен",
    wasNotPresent: "Я не посещал событие",
    dateOfEvent: "Дата события:",
  },
  congratulation: {
    mission: "Поздравляем, миссия %{name} завершена!",
    missionTask: {
      title: "🎉 Поздравляем! Задача %{name} выполнена.",
      content: "До завершения миссии осталось <b>%{need} задач</b> — продолжай в том же духе!",
    },
  },
  accountNotFound: "Этот адрес электронной почты не связан ни с одним образовательным пространством. Свяжитесь с администратором вашей школы",
  demoAccess: "Хотите попробовать SkillzRun для своего бизнеса/школы? Зарегистрируйтесь для тестирования платформы",
  structure: "Структура",
  version: {
    message: "Новая версия приложения доступна. Перезагрузите страницу, чтобы обновить",
    button: "Перезагрузить",
  },
  missions: {
    title: "Миссии",
    startButton: "Старт миссии",
    missionStarted: "Миссия начата %{started}",
    started: "Миссия началась!",
    tasks: {
      title: "Детали задания",
    },
  },
  productCatalog: {
    title: "Каталог продукции",
    coinBalance: "Ваш баланс:",
    notEnoughCoins: "Недостаточно монет",
    order: "Заказать",
    orderConfirmation: "Подтверждение заказа",
    price: "Цена:",
    remaining: "Остаток:",
    instructionForForm: "Чтобы ускорить обработку вашего заказа, заполните данные для получения",
    address: "Адресс",
    thankText: "Спасибо! Ваш заказ оформлен",
    pleaseWait: "Ожидайте, с вами свяжется менеджер",
    pleaseWaitPersona: "Ожидайте СМС, вам придёт ТТН",
    thankTextOffer: "Спасибо! Покупка оформлена",
    contentAvailableText: "Контент уже доступен — можете пользоваться прямо сейчас.",
    deliveryAddress: "Введите адрес доставки",
    helperText: "Укажите полный адрес или город и номер отделения Новой почты/Укрпочты",
    deliveryOptions: "*Варианты доставки будут уточнены с менеджером после получения заказа.",
    validationPhoneFormat: "Номер телефона должен состоять из 10 цифр и начинаться с 0.",
    recipientNameLabel: "ФИО",
    recipientNameRequired: "Пожалуйста, введите имя получателя.",
    npCityRequired: "Пожалуйста, выберите город доставки.",
    npWarehouseRequired: "Пожалуйста, выберите отделение Новой почты.",
    npCityLabel: "Город Новой почты",
    npCityPlaceholder: "Начните вводить название города",
    npCitySearching: "Поиск городов...",
    npCitySelectHint: "Выберите город из списка",
    npCityTypeHint: "Начните вводить название города (не менее 3 символов)",
    npBranchTypeDepartments: "Отделения",
    npBranchTypePostomats: "Поштоматы",
    npWarehouseLabel: "Отделение Новой почты",
    npWarehousePlaceholder: "Выберите отделение",
    npWarehouseLoading: "Загружаем отделения...",
    npWarehouseSelectHint: "Выберите отделение из списка",
    npWarehouseEmpty: "Для этого города отделения не найдены",
    npWarehouseCityFirst: "Сначала выберите город",
    inProcessing: "В обработке",
    purchased: "Куплено",
    oneTimeAlreadyPurchased: "Этот товар уже куплен",
  },
  companyReviewTitle: "Насколько вероятно, что вы порекомендуете нашу школу другу или знакомому?",
  companyReviewText: 'Оцените по шкале от 1 до 10, где 1 означает "совсем не вероятно", а 10 - "очень вероятно"',
  subjectReviewTitle: "Насколько вам было интересно проходить этот курс на платформе",
  subjectReviewText: 'Оцените по шкале от 1 до 10, где 1 означает "совсем не интересно", а 10 - "очень интересно"',
  lessonsCount_one: "%{smart_count} урок",
  lessonsCount_few: "%{smart_count} урока",
  lessonsCount_many: "%{smart_count} уроков",
  policySettings: {
    termsAndConditions: "Правила и условия",
    refund: "Политика конфиденциальности",
  },
  promoCode: "Промокод",
  promoInvalid: "Промокод недействителен",
};
